module.exports = __webpack_public_path__ + "img/noNotif.91c0796b.png";